const sk = {
    "form": {
        "title": "Získajte odškodnenie s DelayFix",
        "paragraph": "Stačí, že pošlete svoju žiadosť a náš konzultant vás bude kontaktovať, aby dohodol podrobnosti.",
        "name": "Meno",
        "second_name": "Priezvisko",
        "number": "Telefónne číslo",
        "mail": {
            "label": "E-mailová adresa",
            "placeholder": "adresa{'@'}email.sk"
        },
        "comment": {
            "btn": "Pridať komentár",
            "label": "Váš komentár",
            "label-sm": "(voliteľné)",
            "placeholder": "Chcete pridať niečo k svojej žiadosti?"
        },
        "error": {
            "empty": "Toto pole nemôže byť prázdne",
            "invalid-email": "Zadajte platnú e-mailovú adresu",
            "invalid-tel": "Zadajte platné telefónne číslo",
            "invalid-url": "Neplatná adresa URL",
            "invalid-name": "Meno môže obsahovať iba písmená",
            "invalid-last-name": "Priezvisko môže obsahovať iba písmená",
            "global": "Vyskytla sa chyba. Skúste to znova neskôr.",
        },
        "btn": "Odoslať"
    },
    "why": {
        "title": "Prečo DelayFix?",
        "paragraph": "Máme bohaté skúsenosti s vedením najnáročnejších prípadov, vrátane prejudiciálnych konaní pred Súdnym dvorom Európskej únie (SDEÚ). Výziev sa nebojíme. Ak je to potrebné, naši právnici sú pripravení odletieť do najvzdialenejších kútov sveta, aby osobne dohliadli na vymáhanie náležitého odškodnenia."
    },
    "reviews": {
        "title": "Hodnotenia našich klientov",
        "description": "Spoznajte hodnotenia tisícok spokojných klientov DelayFix",
    },
    "footer": {
        "text": "Podporujeme cestujúcich poškodených v dôsledku oneskorených alebo zrušených letov",
        "contact": "Kontaktujte nás od pondelka do piatku v čase: 9:00 - 17:00",
        "terms": "Obchodné podmienky",
        "privacy": "Zásady ochrany osobných údajov",
        "capital": "Výška základného imania:"
    },
    "thank-you": {
        "title": "Ďakujeme!",
        "paragraph": "Vaša žiadosť bola odoslaná. Náš konzultant vás bude kontaktovať, aby dohodol podrobnosti.",
        "button": "Pridať ďalšieho cestujúceho"
    }
}

export default sk;